"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertManifestMatches = assertManifestMatches;
const sev1_1 = require("../errors/sev1");
/**
 * Throws if manifest entries drift from the live class exports. Checks:
 *   - Every class name in the manifest has a live class with that name.
 *   - Every live class name is present in the manifest.
 *   - For each entry, `severity` + `httpStatus` match the live class statics.
 *
 * The error message names the first drift so CI logs point to the fix.
 */
function assertManifestMatches(manifest, classes) {
    const manifestNames = Object.keys(manifest.classes).sort();
    const classNames = Object.keys(classes).sort();
    if (manifestNames.join(',') !== classNames.join(',')) {
        throw new sev1_1.ConfigurationError({
            message: `Manifest drift: manifest=[${manifestNames.join(',')}] live=[${classNames.join(',')}]`,
            code: 'MANIFEST_DRIFT_CLASSES',
            details: { manifestNames, classNames },
        });
    }
    for (const name of manifestNames) {
        const entry = manifest.classes[name];
        const Klass = classes[name];
        if (entry.severity !== Klass.severity) {
            throw new sev1_1.ConfigurationError({
                message: `Manifest drift for ${name}: severity manifest=${entry.severity} live=${Klass.severity}`,
                code: 'MANIFEST_DRIFT_SEVERITY',
                details: { className: name, manifestSeverity: entry.severity, liveSeverity: Klass.severity },
            });
        }
        if (entry.httpStatus !== Klass.httpStatus) {
            throw new sev1_1.ConfigurationError({
                message: `Manifest drift for ${name}: httpStatus manifest=${String(entry.httpStatus)} live=${String(Klass.httpStatus)}`,
                code: 'MANIFEST_DRIFT_HTTP_STATUS',
                details: { className: name, manifestHttpStatus: entry.httpStatus, liveHttpStatus: Klass.httpStatus },
            });
        }
    }
}
